import React from 'react'
import { Button } from 'antd'
import { users } from '@services/api'

export default function ViewCode(props) {
    let { phone } = props

    const getVerifyCode = async () => {
        try {
            if (phone.length === 10 && phone[0] === '0') phone = phone.substr(1)
            const result = await users.getVerifyCode({ phone })
            const res = result.data
            alert(res)
        } catch (e) {
            alert(e)
        }
    }

    return (
        <>
            {phone ? (
                <Button onClick={getVerifyCode} style={{ marginLeft: '0px' }}>
                    קוד אימות
                </Button>
            ) : null}
        </>
    )
}
